import * as Types from '@/store/mutation-types'
import { set_many, ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST } from '@/store/mutation-mixins'

export default {

    ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST,

    [Types.SET_MANY]: set_many({ to: 'entities', by: ['variant', 'key'] }),

}
